var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.clickButton('teste')}}},[_vm._v("Socket Test")])])
}
var staticRenderFns = []

export { render, staticRenderFns }